import { z } from 'zod'

export const npsSubmitResponseSchema = z.object({
  success: z.boolean(),
})

export type NpsSubmitResponse = z.infer<typeof npsSubmitResponseSchema>

export const npsReviewStateSchema = z
  .object({
    classId: z.number().int().positive(),
    studentId: z.number().int().positive(),
    tutorId: z.number().int().nonnegative(),
    invoiceStatus: z.string().nullish(),
    classStartDatetimeUtc: z.string().datetime().nullish(),
    canWrite: z.boolean(),
    status: z.enum(['SUBMITTED', 'SKIPPED', 'BLOCKED', 'DELETED']).nullable(),
    rating: z.number().int().min(1).max(5).nullable(),
    reasons: z.array(z.string()),
    reasonText: z.string(),
    wantBlock: z.boolean(),
  })
  .superRefine((review, ctx) => {
    if (review.status === 'SUBMITTED' && review.rating === null) {
      ctx.addIssue({ code: 'custom', message: 'Submitted review has no rating' })
    }
    if (review.canWrite && review.tutorId === 0) {
      ctx.addIssue({ code: 'custom', message: 'Writable review has no tutor' })
    }
  })

export type NpsReviewState = z.infer<typeof npsReviewStateSchema>
